<template>
	<div class="Box">
		<el-card class="box-card">
			<el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
				<el-row :gutter="35">
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="ID">
							<el-input v-model="queryParams.id" @change="search" @clear="search" placeholder="请输入ID" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="模板说明">
							<el-input v-model="queryParams.name" @change="search" @clear="search" placeholder="请输入模板说明" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="创建时间">
							<el-date-picker
								style="width: 100%"
								v-model="valuetimr"
								type="daterange"
								align="right"
								unlink-panels
								start-placeholder="开始时间"
								end-placeholder="结束时间"
								@change="handTime"
							>
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<div class="btn_left">
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="addNoNe">重置</el-button>
						</div>
					</el-col>
				</el-row>
			</el-form>
			<div class="div_buttom">
				<el-button size="medium" type="primary" @click="addrouter">返回</el-button>
				<el-button size="medium" @click="addNoNe">刷新列表</el-button>
				<el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
<!--				<el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
			</div>
			<el-table
				ref="multipleTable"
				:header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				@selection-change="handleSelectionChange"
				border
			>
				<el-table-column label="ID" width="80">
					<template slot-scope="scope">{{ scope.row.id }}</template>
				</el-table-column>

				<el-table-column prop="name" label="模板说明">
					<template slot-scope="scope"> {{ scope.row.name }}</template>
				</el-table-column>
				<el-table-column prop="name" label="模板标签" width="120">
					<!-- <template slot-scope="scope"> -->
					<template slot-scope="scope"> {{ scope.row.recharge_tag_text }}</template>
					<!-- <span v-if="scope.row.status == 0">默认</span>
						<span v-if="scope.row.status == 1">完成</span> -->
					<!-- </template> -->
				</el-table-column>
				<el-table-column prop="name" label="状态" width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 0">无效</span>
						<span v-if="scope.row.status == 1">有效</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="创建人" width="120">
					<template slot-scope="scope">
						<el-tag>{{ scope.row.admin_type_text }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="创建时间">
					<template slot-scope="scope">{{ scope.row.created_at }}</template>
				</el-table-column>

				<el-table-column prop="name" label="更新时间">
					<template slot-scope="scope">{{ scope.row.updated_at }}</template>
				</el-table-column>

				<el-table-column fixed="right" label="操作" width="150">
					<template slot-scope="scope">
						<el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
						<el-button v-if="scope.row.status == 1" type="text" size="medium" @click="addStatus(scope.row)">禁用</el-button>
						<el-button type="text" v-if="scope.row.status == 0" size="medium" @click="addopen(scope.row)">开启</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize" @pagination="getList" />
			<RechargeTemplate v-if="RechargeFlag" :RechargeFlag="RechargeFlag" :paramsMovie="paramsMovie" :id="id" @RechargeNone="RechargeNone" >
			</RechargeTemplate>
		</el-card>
	</div>
</template>

<script>
import { RechargeAPI } from '@/api/popularize/Recharge';
import RechargeTemplate from './component/RechargeTemplate.vue';
export default {
	components: {
		RechargeTemplate,
	},
	data() {
		return {
			queryParams: {
				pageNo: 1,
				pageSize: 10,
				id: '',
				name: '',
				st: '',
				et: '',
				movie_id: '',
			},
			valuetimr: '',
			appidList: [],

			tableData: [],
			multipleSelection: [],
			editID: '',
			// 总条数
			total: 0,
			SearchFlag: false,
			RechargeFlag: false,
			paramsMovie: {
				movie_id: '',
				movie_Name: '',
			},
			id: '',
			mobanIdindex: '',
		};
	},
	created() {
		this.getList();
		let obj = JSON.parse(localStorage.getItem('movie'));
		this.paramsMovie.movie_id = obj.movie_id;
		this.paramsMovie.movie_Name = obj.movie_Name;
	},
	methods: {
		handTime(e) {
			const date = e[0];
			const year = date.getFullYear();
			const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
			const day = ('0' + date.getDate()).slice(-2) - 1;
			const formattedDate = `${year}-${month}-${day}`;

			const dates = e[1];
			const years = dates.getFullYear();
			const months = ('0' + (dates.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
			const days = ('0' + dates.getDate()).slice(-2) - 1;
			const formattedDates = `${years}-${months}-${days}`;
			this.queryParams.st = formattedDate;
			this.queryParams.et = formattedDates;
      this.getList();
		},

		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 搜索
		search() {
			this.getList();
		},
		// 重置列表
		addNoNe() {
			this.queryParams = {
				pageNo: 1,
				pageSize: 10,
			};
			this.getList();
		},
		// 新增按钮事件
		addList() {
			this.id = '';
			this.RechargeFlag = true;
		},
		addopen(row) {
			this.$confirm('确定开启该模板吗 ?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					let api = RechargeAPI();
					let obj = {
						id: row.id,
						status: 1,
					};
					api.statusRecharge(obj).then((res) => {
						// 假设 DelList 接受一个 id，而不是数组
						if (res.code == 0) {
							this.getList();
							this.$message({
								message: '开启成功',
								type: 'success',
							});
						} else {
							this.$message({
								message: '开启失败',
								type: 'error', // 通常使用 'error' 类型表示失败
							});
						}
					});
				})
				.catch(() => {
					this.$message({
						message: '取消删除',
						type: 'info', // 使用 'info' 类型表示提示信息
					});
				});
		},
		addEdit(row) {
			let obj = JSON.parse(localStorage.getItem('movie'));
			this.paramsMovie.movie_id = obj.movie_id;
			this.paramsMovie.movie_Name = obj.movie_Name;
			this.id = row.id;
			this.RechargeFlag = true;
		},
		RechargeNone() {
			this.getList();
			this.RechargeFlag = false;
		},
		
		addrouter() {
			this.$router.go(-1);
		},
		addStatus(row) {
			this.$confirm('确定禁用该模板吗 ?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					let api = RechargeAPI();
					let obj = {
						id: row.id,
						status: 0,
					};
					api.statusRecharge(obj).then((res) => {
						// 假设 DelList 接受一个 id，而不是数组
						if (res.code == 0) {
							this.getList();
							this.$message({
								message: '禁用成功',
								type: 'success',
							});
						} else {
							this.$message({
								message: '禁用失败',
								type: 'error', // 通常使用 'error' 类型表示失败
							});
						}
					});
				})
				.catch(() => {
					this.$message({
						message: '取消删除',
						type: 'info', // 使用 'info' 类型表示提示信息
					});
				});
		},
		getList(){
			this.mobanIdindex = this.$route.query.key;
		if (this.mobanIdindex) {
			let api = RechargeAPI();
			let params = { ...this.queryParams, movie_id: this.mobanIdindex };
			api.getRechargeList(params).then((res) => {
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.totalCount;
				}
			});
		}
		}
	},

	mounted() {
		// this.getList()
		
	},
};
</script>
<style lang="scss" scoped>
.Box {
	& ::v-deep el-card__body {
		padding: 0 !important;
	}
}

.el-card__body {
	padding: 0px !important;
}

.btn_left {
	margin-left: 100px;
}

.div_buttom {
	width: 100%;
	height: 30px;
	display: flex;
	margin-bottom: 20px;
}

.Coimage {
	width: 50px;
	height: 50px;
}
</style>
